import { StatusType } from '../../constants';
import { AvailabilityUserStatus } from '../../types';

const isStatusType = (value: unknown): value is StatusType => {
  return Object.values(StatusType).includes(value as StatusType);
};

export const extractEmployeeStatus = (response: AvailabilityUserStatus): StatusType | null => {
  return isStatusType(response.state) ? response.state : null;
};
